import { timeZone } from '@packages/shared';
import { formatInTimeZone } from 'date-fns-tz';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

export function TimezoneInfo(props: { clinicTimezone?: string }) {
  const clinicTimezone = props.clinicTimezone ?? timeZone;
  const patientTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const isInSameTimezone = useMemo(() => {
    return patientTimezone === clinicTimezone;
  }, [clinicTimezone, patientTimezone]);

  if (isInSameTimezone) return null;

  return (
    <p className="flex justify-between text-sm">
      <CurrentTimeInTimezone timezone={clinicTimezone} />
    </p>
  );
}

/**
 * Component for displaying the current time related to available appointments.
 *
 * @returns The current time in the Europe/Oslo timezone
 */
const CurrentTimeInTimezone = ({ timezone }: { timezone: string }) => {
  const { t } = useTranslation('booking');
  const [currTimeInTimezone, setCurrTimeInTimezone] = useState(
    formatInTimeZone(new Date(), timezone, 'HH:mm'),
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrTimeInTimezone(formatInTimeZone(new Date(), timezone, 'HH:mm'));
    }, 60 * 1000);

    return () => clearInterval(interval);
  }, [timezone]);

  return (
    <span>
      {t('steps.select_datetime.current_time_in_clinics')}
      {currTimeInTimezone}
    </span>
  );
};
